import { AppTagItemEntity } from '@datachain/ui-sdk/components/dc-types';
import { Map, OrderedSet, Record } from 'immutable';

import {
	CharacteristicType,
	DcTimestampFormat,
} from '../../core/dc-core-types';
import { DepotHeaderListEntity } from '../components/create-entity-from-depot-modal/depot-header-list.entity';
import { DepotListEntity } from '../components/depot-list/depot-list.entity';
import { DepotSchemaEntity } from '../components/depot-schema-viewer/depot-schema.entity';
import { SupportedLanguageEntity } from '../domain/supported-language.entity';

export const DepotSliceKey = 'main';

export interface IDepotOriginalSliceState {
	loading: boolean;
	list: DepotListEntity;
	includePublicProjects: boolean;
	headersForSelectRepo: DepotHeaderListEntity;
	availableTags: OrderedSet<AppTagItemEntity>;
	depotSchema: Array<DepotSchemaEntity> | null;
	availableCharacteristicTypes: Map<number, CharacteristicType>;
	availableDateFormats: Map<string, DcTimestampFormat>;
	availableTimezones: Array<string>;
	supportedLanguages: Map<string, SupportedLanguageEntity>;
}

export const defaults: IDepotOriginalSliceState = {
	loading: false,
	list: DepotListEntity.build([]),
	includePublicProjects: false,
	headersForSelectRepo: DepotHeaderListEntity.build([]),
	availableTags: OrderedSet(),
	depotSchema: null,
	availableCharacteristicTypes: Map(),
	availableDateFormats: Map(),
	availableTimezones: [],
	supportedLanguages: Map(),
};

export class DepotOriginalSliceState extends Record<IDepotOriginalSliceState>(
	defaults
) {
	public static readonly key = DepotSliceKey;

	public setLoading(isLoading: boolean): DepotOriginalSliceState {
		return this.set('loading', isLoading);
	}

	public setDepotList(depotList: DepotListEntity): DepotOriginalSliceState {
		return this.set('list', depotList);
	}

	public toggleIncludePublicProjects(
		includePublicProjects: boolean
	): DepotOriginalSliceState {
		return this.set('includePublicProjects', includePublicProjects);
	}

	public setHeadersForSelectRepo(
		headersForSelectRepo: DepotHeaderListEntity
	): DepotOriginalSliceState {
		return this.set('headersForSelectRepo', headersForSelectRepo);
	}

	public setTags(tags: OrderedSet<AppTagItemEntity>): DepotOriginalSliceState {
		return this.set('availableTags', tags);
	}

	public setDepotSchema(
		val: Array<DepotSchemaEntity> | null
	): DepotOriginalSliceState {
		return this.set('depotSchema', val);
	}

	public setAvailableCharacteristicTypes(
		types: Map<number, CharacteristicType>
	): DepotOriginalSliceState {
		return this.set('availableCharacteristicTypes', types);
	}

	public setAvailableDateFormats(
		dateFormats: Map<string, DcTimestampFormat>
	): DepotOriginalSliceState {
		return this.set('availableDateFormats', dateFormats);
	}

	public setAvailableTimezones(val: Array<string>): DepotOriginalSliceState {
		return this.set('availableTimezones', val);
	}

	public setSupportedLanguages(
		val: Map<string, SupportedLanguageEntity>
	): DepotOriginalSliceState {
		return this.set('supportedLanguages', val);
	}

	public deleteHeadersForState(): DepotOriginalSliceState {
		return this.set('headersForSelectRepo', defaults.headersForSelectRepo);
	}
}
